// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e7b3a42","239":"fa63ed3c","453":"ef77296f","455":"572c8190"}[chunkId] + ".chunk.js";
};